import { categories, timeline } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const catMeta: Record<string, { icon: string; desc: string; color: string }> = {
  影视热点: { icon: "ri-film-line", desc: "剧集、电影、演员动态等影视圈大事", color: "bg-primary-100 text-primary-700" },
  综艺话题: { icon: "ri-tv-2-line", desc: "综艺开播、收官与节目内外的热议话题", color: "bg-accent-100 text-accent-800" },
  音乐现场: { icon: "ri-mic-line", desc: "演唱会、音乐节与音乐人相关进展", color: "bg-secondary-100 text-secondary-800" },
  时尚品牌: { icon: "ri-handbag-line", desc: "代言官宣与品牌层面的热点事件", color: "bg-primary-100 text-primary-700" },
  行业观察: { icon: "ri-line-chart-line", desc: "平台规则与文娱产业的结构性变化", color: "bg-accent-100 text-accent-800" },
};

const countFor = (name: string) => timeline.filter((t) => t.category === name).length;

const steps = [
  { n: "01", t: "锁定信息源", d: "先确认事件最早由谁、在哪个渠道放出，避免被拼接误导。" },
  { n: "02", t: "还原回应顺序", d: "按时间排好各方回应与澄清，理清谁的发言在前、谁的在后。" },
  { n: "03", t: "识别热度拐点", d: "找到舆论真正爆发的节点，往往也是信息扩散最快的一环。" },
  { n: "04", t: "复盘收尾", d: "观察事件如何降温或收束，完整的脉络才算真正看明白。" },
];

export default function Guide() {
  const list = categories.filter((c) => c !== "全部");

  return (
    <section id="guide" className="bg-background-50 py-14 md:py-20">
      <div className="container-x">
        <SectionHeading
          eyebrow="Browse by Topic"
          title="内容导览：按门类吃瓜"
          desc="本月大瓜分散在不同领域。按下面的门类点选，就能在时间线里只看到你关心的那一路经过。"
        />

        <div className="mt-8 grid gap-4 sm:grid-cols-2 md:mt-10 lg:grid-cols-5">
          {list.map((c) => {
            const meta = catMeta[c];
            return (
              <a
                key={c}
                href="#timeline"
                className="group rounded-xl bg-background-100 p-5 ring-1 ring-background-200 transition-all hover:-translate-y-1 hover:ring-primary-300"
              >
                <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${meta?.color || "bg-secondary-100 text-secondary-700"}`}>
                  <i className={`${meta?.icon || "ri-file-list-line"} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c}</h3>
                <p className="mt-1.5 text-[13px] leading-5 text-foreground-500">{meta?.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600">
                  {countFor(c)} 条脉络 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </a>
            );
          })}
        </div>

        <div className="mt-14 md:mt-16">
          <div className="flex flex-col items-start gap-3 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading
              eyebrow="How to Read"
              title="一套大瓜，这样看才不迷路"
              desc="把复杂的吃瓜过程拆成四步，顺着这个节奏，任何人都能快速读懂一件大瓜的完整脉络。"
            />
          </div>
          <ol className="mt-8 grid gap-4 md:mt-10 md:grid-cols-2 lg:grid-cols-4">
            {steps.map((s) => (
              <li key={s.n} className="relative rounded-xl bg-background-100 p-6 ring-1 ring-background-200">
                <span className="font-heading text-3xl font-black text-accent-500/60">{s.n}</span>
                <h4 className="mt-3 text-base font-bold text-foreground-950">{s.t}</h4>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{s.d}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}